/** @module Enums */ /** typedoc */

/* tslint:disable */
export enum RegexPatterns {
    Email = '^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&\'*+/0-9=?A-Z^_`a-z{|}~]+(.[-!#$%&\'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$',
    Duration= '^([0-5]?[0-9])?(:[0-5]?[0-9])$'
}
/* tslint:enable */
